import { useFrame } from "@react-three/fiber"
import { useRef } from "react"
import type { Group } from "three"
import type { LandingData } from "../data/types"
import { scenePresence, sectionFocus, type LandingMotionRef } from "../lib/landing-motion"
import { applyGroupOpacity } from "../lib/three"
import { SceneText } from "./SceneText"

export function StatsCounters({ data, motion }: { data: LandingData; motion: LandingMotionRef }) {
  const group = useRef<Group>(null)
  const labels = [
    `${data.stats.symbols} SYMBOLS`,
    `${data.stats.etfs} ETFS`,
    `${data.stats.exchanges} EXCHANGES`,
    `${data.stats.news_articles} ARTICLES`,
  ]

  useFrame((_, delta) => {
    const section = motion.current.section
    const presence = scenePresence(section, 5.28, 7.35, 0.5)
    const focus = sectionFocus(section, 6, 0.95)
    const final = sectionFocus(section, 7, 0.86)
    if (!group.current) return
    group.current.position.set(final * -0.08, -0.08 + final * 0.05, -0.7 + presence * 0.74)
    group.current.scale.setScalar(1.86 + focus * 0.22 + final * 0.18)
    group.current.rotation.y += delta * (0.13 + focus * 0.08)
    group.current.rotation.z = final * 0.08
    applyGroupOpacity(group.current, presence)
  })

  return (
    <group ref={group} scale={2.05}>
      <mesh>
        <torusGeometry args={[1.5, 0.012, 12, 160]} />
        <meshBasicMaterial color="#14d8b4" transparent opacity={0.42} />
      </mesh>
      <mesh rotation={[0, 0, Math.PI / 4]}>
        <torusGeometry args={[1.1, 0.006, 8, 128]} />
        <meshBasicMaterial color="#7af0d8" transparent opacity={0.22} />
      </mesh>
      <mesh rotation={[0, Math.PI / 2, 0]}>
        <torusGeometry args={[1.32, 0.006, 8, 128]} />
        <meshBasicMaterial color="#0fa98d" transparent opacity={0.18} />
      </mesh>
      {labels.map((text, i) => {
        const angle = i * Math.PI / 2
        return (
          <SceneText key={text} position={[Math.cos(angle) * 1.9, Math.sin(angle) * 1.02, 0.02]} fontSize={0.16} color="#f2f5f4" fillOpacity={0.48}>
            {text}
          </SceneText>
        )
      })}
    </group>
  )
}
